import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CommonProperties } from '../../styles';

const Summary = ({ style, ...rest }) => {
  return <View style={[styles.list, style]} {...rest} />;
};

export default Summary;

const styles = StyleSheet.create({
  list: {
    //flex: 1,
    ...CommonProperties.mt2,
    ...CommonProperties.mb5,
  },
});
